var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{style:(_vm.style)},[_vm._t("default"),(_vm.title)?_c('v-card-title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-card-text',{staticClass:"text-card",domProps:{"innerHTML":_vm._s(_vm.content)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }